<template>
    <GetStartedLayout
        :errors="errors"
        title=""
        subtitle=""
        :breadcrumbs="breadcrumbs"
        :helpForm="false"
        :guest="guest || user"
        :location="user?.selected_location || guest?.location"
        ref="layout"
    >
        <v-col
            class="white--text text-center px-0"
            cols="12"
            sm="10"
            md="8"
            lg="6"
        >
            <v-form ref="form" @submit.prevent="submit" v-model="valid">
                <FormTitle class="pa-4 pt-0" dark>Checkout</FormTitle>

                <ShoppingCartItems
                    ref="items"
                    :user="user"
                    :guest="guest"
                    :errors="errors"
                    :items="items"
                    @update="updateItem($event)"
                    @delete="deleteItem($event)"
                    @clear="clearCart()"
                    @viewContract="viewContracts = true"
                />

                <ShoppingCartPayment
                    v-if="items.length"
                    ref="payment"
                    :user="user"
                    :guest="guest"
                    :errors="errors"
                    :items="items"
                    :subtotal="subtotal"
                    v-model="form.paymentMethod"
                    @applyPromo="applyPromo($event)"
                    @applyGift="applyGift($event)"
                    @stripeLoaded="stripeLoaded = true"
                    ><template #validate>
                        <v-input
                            v-if="false"
                            class="px-2"
                            hide-details="auto"
                            :value="form.paymentMethod"
                            :rules="[
                                (val) =>
                                    val !== null ||
                                    !totalAmountDue ||
                                    'A payment method is required',
                            ]"
                            :error-messages="form.paymentMethod" /></template
                ></ShoppingCartPayment>

                <ShoppingCartSummary
                    v-if="items.length"
                    ref="summary"
                    :user="user"
                    :guest="guest"
                    :errors="errors"
                    :items="items"
                    :subtotal="subtotal"
                    :totalAmountDue="totalAmountDue"
                    :autoCoupons="autoCoupons"
                    :appliedGift="form.appliedGift"
                    :appliedPromo="form.appliedPromo"
                    :appliedBalance="getAppliedBalance"
                    ><template #submit> </template
                ></ShoppingCartSummary>
                <FormSubmit
                    v-if="!viewContracts && !hasUnsignedContracts"
                    dark
                    type="submit"
                    :loading="loading"
                    :valid="valid && !!items.length"
                    :errors="errors"
                    gradient="gradient-orange"
                    icon=""
                    :text="`Pay ${formatUnitAmount(totalAmountDue)}`"
                    :disabled="!stripeLoaded"
                />
                <p v-if="guest?.location?.isOpen === false" class="py-2">
                    Fully refundable until your first lesson or class
                </p>
            </v-form>
            <FormSubmit
                v-if="hasUnsignedContracts"
                dark
                valid
                :loading="loading"
                :errors="errors"
                gradient="gradient-orange"
                icon=""
                text="Review Agreements"
                @submit="viewContracts = true"
            />
        </v-col>

        <ShoppingCartContracts
            v-if="viewContracts"
            :items="items"
            :errors="errors"
            :user="user"
            :guest="guest"
            routeName="shoppingCart.storeContract"
            @reset="closeModal(() => (viewContracts = false))"
            @success="
                closeModal(
                    () => (viewContracts = false),
                    ($refs.layout.showMessage = true)
                )
            "
        />

        <SoliChoice
            v-if="registrationAlert"
            title="Edit Registration?"
            subtitle="This shopping cart item is an event registration. Continue to registration page?"
            button1="Continue"
            button2="Nevermind"
            @option1="
                $inertia.get(
                    route('eventRegistration.create', {
                        eventRegister: registrationAlert,
                    })
                )
            "
            @reset="closeModal(() => (registrationAlert = false))"
        />
    </GetStartedLayout>
</template>

<script>
import GetStartedLayout from "../../Layouts/GetStartedLayout.vue";
import FormTitle from "../../Components/Form/FormTitle.vue";
import FormSubmit from "../../Components/Form/FormSubmit.vue";
import ShoppingCartPayment from "../../Components/ShoppingCart/ShoppingCartPayment.vue";
import ShoppingCartSummary from "../../Components/ShoppingCart/ShoppingCartSummary.vue";
import ShoppingCartItems from "../../Components/ShoppingCart/ShoppingCartItems.vue";
import ShoppingCartContracts from "../../Components/ShoppingCart/ShoppingCartContracts.vue";

export default {
    components: {
        GetStartedLayout,
        FormTitle,
        FormSubmit,
        ShoppingCartPayment,
        ShoppingCartSummary,
        ShoppingCartItems,
        ShoppingCartContracts,
    },
    props: {
        errors: {
            type: Object,
            default: () => {},
        },
        user: {
            type: Object,
            default: () => {},
        },
        guest: {
            type: Object,
            default: () => {},
        },
        items: {
            type: Array,
            default: () => [],
        },
        taxRate: {
            type: Number,
            default: {},
        },
        autoCoupons: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            breadcrumbs: ["Home", "Checkout"],
            loading: false,
            valid: false,
            registrationAlert: false,
            viewContracts: false,
            stripeLoaded: false,
            form: this.$inertia.form({
                totalAmountDue: null,
                paymentMethod: null,
                autoCouponIds: null,
                appliedPromo: null,
                appliedGift: null,
                updateDefaultPaymentMethod: true,
                //contractUrls: [],
            }),
        };
    },
    methods: {
        clearCart() {
            this.$inertia.delete(route("shoppingCart.clear"), {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    this.$refs.layout.showMessage = true;
                },
                onError: (errors) => {
                    console.log(
                        "Form returned errors: " + JSON.stringify(errors)
                    );
                },
            });
        },
        deleteItem(item) {
            this.$inertia.delete(route("shoppingCart.delete", item.id), {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    this.$refs.layout.showMessage = true;
                },
                onError: (errors) => {
                    console.log(
                        "Form returned errors: " + JSON.stringify(errors)
                    );
                },
            });
        },
        updateItem({ item, quantity }) {
            if (item.event_register) {
                this.registrationAlert = item.event_register.hash_id;
                return;
            }

            this.$inertia.put(
                route("shoppingCart.update", item.id),
                { quantity: quantity },
                {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$refs.layout.showMessage = true;
                    },
                    onError: (errors) => {
                        console.log(
                            "Form returned errors: " + JSON.stringify(errors)
                        );
                    },
                }
            );
        },
        async submit() {
            if (!this.$refs.form.validate()) {
                this.$nextTick(() => {
                    const el = document.querySelector(
                        ".v-messages.error--text"
                    );
                    el.scrollIntoView({ block: "center" });
                });
                return;
            }

            this.loading = true;

            if (!this.form.paymentMethod && this.totalAmountDue !== null) {
                await this.$refs.payment.storePaymentMethod();
            }

            if (!this.form.paymentMethod && this.totalAmountDue !== null) {
                this.loading = false;
                return;
            }

            this.form
                .transform((data) => ({
                    totalAmountDue: this.totalAmountDue,
                    paymentMethodId: data.paymentMethod?.id ?? null,
                    promoId: data.appliedPromo?.id ?? null,
                    giftId: data.appliedGift?.id ?? null,
                    autoCouponIds: this.autoCoupons.map(
                        (e) => e.auto_coupon_ids
                    ),
                    updateDefaultPaymentMethod: !data.paymentMethod?.id
                        ? false
                        : data.updateDefaultPaymentMethod,
                    itemCount: this.items.length,
                }))
                .post(route("checkout.purchase"), {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.loading = false;
                    },
                    onError: (errors) => {
                        console.log(
                            "Form returned errors: " + JSON.stringify(errors)
                        );
                        this.loading = false;
                    },
                });
        },
        applyPromo(promo) {
            this.resetPromo();
            this.form.appliedPromo = promo;
            this.$refs.layout.showMessage = true;
        },
        applyGift(gift) {
            this.resetPromo();
            this.form.appliedGift = gift;
            this.$refs.layout.showMessage = true;
        },
        resetPromo() {
            this.giftDiscount = null;
            this.form.appliedGift = null;
            this.form.appliedPromo = null;
        },
    },
    computed: {
        subtotal() {
            if (!this.items.length) return 0;
            return Object.entries(this.items).reduce((total, [key, item]) => {
                return total + item.price.unit_amount * item.quantity;
            }, 0);
        },
        afterTaxAndDiscounts() {
            const afterTax = this.subtotal + this.getTaxAmount;
            const adjustments =
                this.getGiftAmount +
                this.getPromoAmount +
                this.getAppliedAutoCouponAmount;

            return afterTax - adjustments;
        },
        totalAmountDue() {
            const balance = this.user?.balance ?? 0;
            const totalDue = this.afterTaxAndDiscounts + balance;
            return totalDue > 0 ? totalDue : 0;
        },
        getAppliedBalance() {
            const balance = this.user?.balance ?? 0;
            const totalDue = this.afterTaxAndDiscounts;

            return balance * -1 > totalDue
                ? totalDue * -1
                : balance + totalDue - totalDue;
        },
        getAppliedAutoCouponAmount() {
            return this.autoCoupons
                .map((e) => e.auto_coupon_amount)
                .reduce((a, b) => a + b, 0);
        },
        getGiftAmount() {
            if (!this.form.appliedGift) return 0;
            let remainingGift = this.form.appliedGift.amount - this.subtotal;
            if (remainingGift > 0) return 0;
            return this.subtotal - this.form.appliedGift.amount;
        },
        getPromoAmount() {
            if (!this.form.appliedPromo) return 0;
            let remainingBalance =
                this.subtotal - this.form.appliedPromo.amount;
            if (remainingBalance >= 0) return this.form.appliedPromo.amount;
            return 0;
        },
        getTaxable() {
            return this.items
                .filter((e) => e.taxable)
                .map((e) => e.price.unit_amount * this.taxRate);
        },
        getTaxAmount() {
            if (!this.getTaxable.length) return 0;
            return taxable.reduce((a, b) => a + b);
        },
        getContractItems() {
            return this.items.filter((e) => e.product.contract_id);
        },
        hasUnsignedContracts() {
            return !!this.getContractItems.filter((e) => !e.contract_url)
                .length;
        },
    },
    /*created() {
        this.$loadScript("https://js.stripe.com/v3/");
    },*/
};
</script>

<style scoped></style>
